import { Fragment, useContext, useState } from 'react';

import {
  alpha,
  Box,
  List,
  styled,
  Button,
  ListItem,
  Collapse
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';

import {
  Add,
  AdminPanelSettings,
  Article,
  BadgeOutlined,
  Circle,
  ExpandLess,
  ExpandMore,
  Group,
  Home,
  PersonAdd,
  PhoneDisabled
} from '@mui/icons-material';

const menuItems = [
  { label: 'Home', icon: <Home />, to: '/home' },
  {
    label: 'Users',
    icon: <Group />,
    to: '/users'
    // subItems: [
    //   { label: 'Users', icon: <Group />, to: '/users' },
    //   {
    //     label: 'Roles',
    //     icon: <AdminPanelSettings />,
    //     to: '/roles'
    //   },
    //   { label: 'Add Employee', icon: <PersonAdd />, to: '/add-employee' }
    // ]
  },
  {
    label: 'Employees',
    icon: <BadgeOutlined />,
    to: '/employees'
  },
  // { label: 'Add Extension', icon: <Add />, to: '/add-extension' },
  { label: 'Reports', icon: <Article />, to: '/reports' },
  { label: 'Cancelled Calls', icon: <PhoneDisabled />, to: '/cancelled-calls' }
];

const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(1)};

    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
    }
  }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: ${theme.colors.alpha.trueWhite[50]};
      padding: ${theme.spacing(0, 2.5)};
      line-height: 1.4;
    }
`
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {

      .MuiListItem-root {
        padding: 1px 0;

        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(3.2)};

          .MuiBadge-standard {
            background: ${theme.colors.primary.main};
            font-size: ${theme.typography.pxToRem(10)};
            font-weight: bold;
            text-transform: uppercase;
            color: ${theme.palette.primary.contrastText};
          }
        }
    
        .MuiButton-root {
          display: flex;
          color: ${theme.colors.alpha.trueWhite[70]};
          background-color: transparent;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};

          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(['color'])};

            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }

          .MuiButton-startIcon {
            color: ${theme.colors.alpha.trueWhite[30]};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
          }
          
          .MuiButton-endIcon {
            color: ${theme.colors.alpha.trueWhite[50]};
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }

          &.active,
          &:hover {
            background-color: ${alpha(theme.colors.alpha.trueWhite[100], 0.06)};
            color: ${theme.colors.alpha.trueWhite[100]};

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.colors.alpha.trueWhite[100]};
            }
          }
        }

        &.Mui-children {
          flex-direction: column;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(7)};
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 1px 0;

            .MuiButton-root {
              padding: ${theme.spacing(0.8, 3)};

              .MuiBadge-root {
                right: ${theme.spacing(3.2)};
              }

              &:before {
                content: ' ';
                background: ${theme.colors.alpha.trueWhite[100]};
                opacity: 0;
                transition: ${theme.transitions.create([
                  'transform',
                  'opacity'
                ])};
                width: 6px;
                height: 6px;
                transform: scale(0);
                transform-origin: center;
                border-radius: 20px;
                margin-right: ${theme.spacing(1.8)};
              }

              &.active,
              &:hover {

                &:before {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
`
);

function SidebarMenu() {
  const { closeSidebar } = useContext(SidebarContext);

  const [openSections, setOpenSections] = useState<{ [key: string]: boolean }>({
    userManagement: false,
    reports: false
  });

  const toggleSection = (section: string) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <MenuWrapper>
      <SubMenuWrapper>
        <List component="div">
          {menuItems.map((item) => (
            <Fragment key={item.label}>
              <ListItem component="div">
                {/* {item.subItems ? (
                  <Button
                    disableRipple
                    onClick={() => toggleSection(item.label)}
                    startIcon={item.icon}
                    endIcon={
                      openSections[item.label] ? <ExpandLess /> : <ExpandMore />
                    }
                    sx={{
                      bgcolor: openSections[item.label]
                        ? '#ffffff0f !important'
                        : 'transparent'
                    }}
                  >
                    {item.label}
                  </Button>
                ) : (
                  <Button
                    disableRipple
                    component={RouterLink}
                    to={item.to}
                    onClick={closeSidebar}
                    startIcon={item.icon}
                  >
                    {item.label}
                  </Button>
                )} */}
                <Button
                  disableRipple
                  component={RouterLink}
                  to={item.to}
                  onClick={closeSidebar}
                  startIcon={item.icon}
                >
                  {item.label}
                </Button>
              </ListItem>
              {/* {item.subItems && (
                <Collapse
                  in={openSections[item.label]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div">
                    {item.subItems.map((subItem) => (
                      <ListItem key={subItem.label} component="div" sx={{}}>
                        <Button
                          disableRipple
                          component={RouterLink}
                          onClick={closeSidebar}
                          to={subItem.to}
                          startIcon={
                            <Circle
                              className="icon"
                              sx={{
                                width: 10,
                                height: 10,

                                transition: '0.3s'
                              }}
                            />
                          }
                          sx={{ py: '6px !important' }}
                        >
                          {subItem.label}
                        </Button>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )} */}
            </Fragment>
          ))}
        </List>
      </SubMenuWrapper>
    </MenuWrapper>
  );
}

export default SidebarMenu;
